module.exports = __webpack_public_path__ + "static/n5consulting-left-12d07e2de14b96592165952841d998b7.mp4";